import { ApiService } from "Services/ApiService";
import { ChangePasswordRequestDTO } from "Types/Admin/AdminChangePasswordType";
import { ResultsDTO } from "Types/ResultsDTO";

export const changePasswordApiSlice = ApiService.injectEndpoints({
  endpoints: (builder) => ({
    changePassword: builder.mutation<ResultsDTO, ChangePasswordRequestDTO>({
      query: (data) => ({
        url: "user-settings/change-password",
        method: "PUT",
        body: data,
      }),
    }),
  }),
});

export const { useChangePasswordMutation } = changePasswordApiSlice;
